import { useState } from 'react'
import { LoginTabs } from './LoginTabs'
import { PhoneLoginForm } from './PhoneLoginForm'
import { UsernameLoginForm } from './UsernameLoginForm'
import { SwitchToRegisterButton } from './SwitchToRegisterButton'

interface LoginFormProps {
  onSwitchToRegister: () => void
  onHeightChange?: () => void
  idPrefix?: string
}

const loginTabs = [
  { key: 'account', label: '账号登录' },
  { key: 'phone', label: '验证码登录' },
]

export const LoginForm = ({
  onSwitchToRegister,
  onHeightChange,
  idPrefix = '',
}: LoginFormProps) => {
  const [activeTab, setActiveTab] = useState('account')

  const handleTabChange = (tab: string) => {
    setActiveTab(tab)
    // 延迟触发高度更新，让DOM先更新
    setTimeout(() => {
      onHeightChange?.()
    }, 50)
  }

  return (
    <div className="w-full">
      <div className="mb-8">
        <LoginTabs
          options={loginTabs}
          activeKey={activeTab}
          onChange={handleTabChange}
        />
      </div>

      <div>
        {activeTab === 'account' ? (
          <div className="space-y-6">
            <UsernameLoginForm idPrefix={idPrefix} />
            <div className="flex flex-col items-center space-y-6">
              <SwitchToRegisterButton onSwitchToRegister={onSwitchToRegister} />
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <PhoneLoginForm idPrefix={idPrefix} />
            <div className="flex flex-col items-center space-y-6">
              <SwitchToRegisterButton onSwitchToRegister={onSwitchToRegister} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
